



























import $ from 'jquery'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ContentsService from '@/services/api/contents'
import AppId from '@/util/appid'
import { InstanceResolver } from '@/util/instanceResolver'
import SuggestList from './search-keyword/SuggestList.vue'

@Component({
  components: {
    SuggestList,
  },
})
export default class SearchKeyword extends Vue {
  @Prop({ default: null })
  brand: string | null

  contentsService: ContentsService = new ContentsService(this.appId)

  showSuggest: boolean = false
  hasError: boolean = false

  styleOfSuggest: {
    width: string;
  } = {
    width: '0',
  }

  keyword: string = ''
  suggestList: string[] = []

  get appId(): string {
    return AppId.getByBrandName(this.brand)
  }

  /**
   * ホテラバではキーワード検索を専用商品一覧(/itemlist)自身が持ち、/itemlist/search は
   * htaccessで/itemlistへ301される。リダイレクトを1回挟まないよう直接遷移し、
   * クエリ名も専用一覧の語彙(q)を使う(keywordsも互換として解釈されるが、正規の語彙で送る)。
   */
  get isForHlItemlist(): boolean {
    return BehaviorConfig.createFromBrand(this.brand).isHotellovers
  }

  get keywordQueryName(): string {
    return this.isForHlItemlist ? 'q' : 'keywords'
  }

  get actionUrl(): string {
    if (this.isForHlItemlist) {
      return '/itemlist'
    }

    const path = _.compact([
      !InstanceResolver.isSingle() ? this.brand : '',
      'itemlist',
      'search',
    ]).join('/')

    return `/${path}`
  }

  get hasSuggestList(): boolean {
    return this.suggestList.length > 0
  }

  async mounted() {
    const result = await this.contentsService.get(`RecommendKeyWords`)

    if (result.isLeft()) {
      this.hasError = true

      return
    }
    const data = result.value as any
    this.suggestList = (data.content as string).split(',').map(k => k.trim()).filter(k => k !== '')
  }

  onFocus() {
    const target = $('.c-searchKeyword')
    // サジェストボックスの幅を検索ボックスの幅にそろえる
    this.styleOfSuggest.width = `${target.outerWidth() || 0}px`
    this.showSuggest = !this.hasError && this.hasSuggestList
  }
  onSelect(selected: string) {
    this.keyword = selected

    this.hideSuggest()
  }

  hideSuggest() {
    this.showSuggest = false
  }
}
